<template>
  <form @submit.prevent="saveSchool" class="w-full">
    <div class="flex flex-col w-full" v-if="newSchool">
      <span class="border-b-2 w-full p-2 uppercase border-grey-academy-150
      bg-beige-academy-200" v-if="!addNewUnknownSchool">
        {{ newSchool.school_name }}, {{ newSchool.city}}, {{newSchool.country}}
      </span>
      <div v-else class="flex flex-col">
        <div class="flex justify-between items-center mt-3">
          <label for="school" class="w-1/3">{{$t('skills.school-name')}}:</label>
          <input type="text" id="school" v-model="newSchool.school_name" required
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
        <div class="flex justify-between items-center mt-3">
          <label for="city" class="w-1/3">{{$t('skills.city')}}:</label>
          <input type="text" id="city" v-model="newSchool.city" required
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
        <div class="flex justify-between items-center mt-3">
          <label for="state" class="w-1/3">{{$t('skills.province')}}:</label>
          <input type="text" id="state" v-model="newSchool.state"
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
        <div class="flex justify-between items-center mt-3">
          <label for="country" class="w-1/3">{{$t('skills.nation')}}:</label>
          <input type="text" id="country" v-model="newSchool.country" required
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="course" class="w-1/3">{{$t('skills.course-attended')}}:</label>
        <input type="text" id="course" v-model="newSchoolData.course_title"
        class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="years" class="w-1/3">{{$t('skills.attended-year')}}:</label>
        <input type="text" id="years" v-model="newSchoolData.year" required
        class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200"
        @keyup="resetErrorField('year')">
        <span class="text-red-500"
          v-if="errors.has('year')"
          v-text="errors.get('year')"
        >
        </span>
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="qualification" class="w-1/3">{{$t('skills.title')}}:</label>
        <input type="text" id="qualification" v-model="newSchoolData.qualification" required
        class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
      </div>
    </div>
    <div v-if="value && !newSchool" class="w-full">
      <auto-suggest-school @selected="schoolSelected($event)"
      v-model="schoolDigit" @empty="emptyAlgoliaSchools = true" />
    </div>
    <div class="w-full">
      <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
      hover:bg-white hover:text-orange-academy-300 border-orange-academy-300"
      @click.prevent="$emit('input', true)" v-if="!newSchool && !emptyAlgoliaSchools">
        {{$t('skills.add')}}
      </button>
      <div v-if="newSchool" class="flex items-center">
        <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border mr-6
        hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 mt-6"
        @click.prevent="reset" >
        {{$t('bookingSlots.cancel')}}
        </button>
        <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
        hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 mt-6">
          {{$t('skills.save')}}
        </button>
      </div>
      <div v-if="emptyAlgoliaSchools && !newSchool && value"
      class="flex w-full justify-end items-center">
        {{$t('skills.new-school')}}
        <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
          hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 ml-4"
          @click.prevent="addNewSchool" >
            {{$t('skills.add-school')}}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import AutoSuggestSchool from '@/components/AutoSuggestSchool.vue';
import Errors from '@/util/Errors';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['value'],

  components: {
    AutoSuggestSchool,
  },

  data() {
    return {
      addNewUnknownSchool: false,
      newSchool: null,
      newSchoolData: {
        course_title: '',
        year: '',
        qualification: '',
      },
      schoolDigit: '',
      emptyAlgoliaSchools: false,
      errors: new Errors(),
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  methods: {
    resetErrorField(field) {
      this.errors.clear(field);
    },
    schoolSelected(school) {
      this.newSchool = school.item;
    },

    addNewSchool() {
      this.addNewUnknownSchool = true;
      this.newSchool = {
        school_name: this.schoolDigit,
        city: '',
        state: '',
        country: '',
      };
    },

    saveSchool() {
      if (!this.newSchool.id) {
        axios.post('/api/schools', this.newSchool).then(({ data }) => {
          this.newSchool = data;
          this.addStudentSchool();
        });
        return;
      }
      this.addStudentSchool();
    },

    addStudentSchool() {
      axios.post(`/api/students/${this.user.student.id}/schools/${this.newSchool.id}`, this.newSchoolData).then(() => {
        this.$emit('school-added');
        this.reset();
      }).catch(({ response: { data: { errors } } }) => {
        this.errors.record(errors);
      });
    },

    reset() {
      this.$emit('input', false);
      this.newSchool = null;
      this.addNewUnknownSchool = false;
      this.newSchoolData = {
        course_title: '',
        year: '',
        qualification: '',
      };
      this.emptyAlgoliaSchools = false;
    },

  },
};
</script>
